import React from 'react'
import styled from 'styled-components'
import { push } from 'gatsby-link'

const Component = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${props => `url(${props.image})  no-repeat center center`};
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  magin: 0;
  padding: 0;
  overflow: hidden !important;
  pointer-events: auto !important;
`
// mobile version, based on viewport width
// maybe the image will need to be lazy...
const Slide = ({ image }) => {
  return <Component image={image} />
}

export default Slide



// WEBPACK FOOTER //
// ./src/components/slide.js